import React, { useEffect, useState, useContext } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Icon_finalOffer from "../../assets/svg/EPL_think_svg/offerGif.gif";
import Icon_finalOffer_New from "../../assets/svg/EPL_think_svg/thankyoudisburse.gif";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import {
  GetCustomerDetailsContext,
  validateInputExistenece,
} from "../../App";

import LoanSummaryTextItem from "../loan-agreement/_styles/EPL_LoanSummaryTextItem";
import Text from "../loan-agreement/_styles/EPL_Text";
import { LoanSummaryWrapper } from "../loan-summary/_styles/LoanSummaryWrapper";
import { isStageLogin } from "../../shared/validations/StageLogin";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const LoanSummary = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [totalLoanAmount, setTotalLoanAmount] = useState(Number(170000));
  const [emiAmount, setEmiAmount] = useState(Number(29000));
  const [processingFee, setProcessingFee] = useState(Number(1000));
  const [insuranceAmount, setInsuranceAmount] = useState(Number(1500));
  const [tenure, setTenure] = useState(12);
  const otpWaitTime = "00:10";
  const [interestRate, setInterestRate] = useState(12);
  const [showEmailOTPModal, setShowEmailOTPModal] = useState();
  const [oldTime, setOldTime] = useState(otpWaitTime);
  const [timer, setTimer] = useState(otpWaitTime);
  const [load, setLoad] = useState();
  const [otp1, setOTP1] = useState();
  const [otp2, setOTP2] = useState();
  const [otp3, setOTP3] = useState();
  const [otp4, setOTP4] = useState();
  const [otp5, setOTP5] = useState();
  const [otp6, setOTP6] = useState();
  const [otpSent, setOtpSent] = useState(false);
  const [resumeTimer, setResumeTimer] = useState(false);
  const [modal, setModal] = useState("");
  const [showTimer, setShowTimer] = useState(false);
  const [resendOtpButtonDisabled, setResjendOtpButtonDisabled] = useState(true);
  const [emiStartDate, setEmiStartDate] = useState();

  const [mobNum, setMobNum] = useState("");
  const [ischecked, setIsChecked] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(false);

  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("LoanSummary customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed
      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    } else {
      // console.log("LoanSummary Ouch customerDetails ", location);
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      if (customerDetails?.Data?.message === "ERROR: Ce offer validity has failed" || customerDetails?.Data?.message === "ERROR: Line Freezed" || customerDetails?.Data?.message === "ERROR: PAN number - Bank account combination mismatch") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: 'rejected',
        });
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      }
    }
  }, [customerDetails]);
  function convertDate(date_str) {
    var dArr = date_str.split("-");  // ex input: "2010-01-18"	
    var new_date = dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0); //ex output: "18/01/10"
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let temp_date = new_date.split("/");
    return (
      temp_date[0] + " " + months[Number(temp_date[1]) - 1] + " " + temp_date[2]
    );
  }

  function appendRupee(x) {
    const converted = new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 21,
      style: "currency",
      currency: "INR",
    }).format(x);
    return converted;
  }

  const [existingLoanBalance, setExistingLoanBalance] = useState();
  const [oldLoanAccountNumber, setOldLoanAccountNumber] = useState();

  useEffect(() => {
    isStageLogin(
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    setTimeout(() => {
      moengage.track_event("congrats", {
        "journey name": customerDetails?.source,
        disbursementScreen: "reached",
      });
    }, 1000)

    if (customerDetails.source === "upsell") {
      setExistingLoanBalance(
        parseInt(customerDetails?.Data?.old_loan_amount) || 0
      );
      setOldLoanAccountNumber(customerDetails?.Data?.old_loan_account_number);
      // setTotalLoanAmountForUpsell(customerDetails?.Data?.old_loan_amount + customerDetails?.Data?.max_topup)
    }
    // setEmiStartDate(customerDetails?.Data?.emi_date);
    // window.scrollTo(0, 0);
  }, []);

  // useEffect(async () => {
  //   await GetCustomerDetails(
  //     customerDetails.application_form_number,
  //     customerDetails.source,
  //     customerDetails,
  //     setCustomerDetails
  //   );
  //   console.log("Called GetCustomerDetails --- LoanSummary");
  //   console.log(customerDetails);
  // }, []);

  return (
    <>
      <AfterLoginLayoutWrapper>
        <LoanSummaryWrapper className="first-child">
          <ShimmerPlaceholder
            height="2.5em"
            marginTop="1em"
            width="12em"
            visible={showShimmer}
          />
          {customerDetails?.stage === "DISBURSEMENT_COMPLETED" ? (
            <Title
              text={`Congrats!`}
              visible={!showShimmer}
              clickable={false}
              style={{
                fontSize: "30px",
              }}
            />
          ) : (
            <Title
              text={`Thank you!`}
              visible={!showShimmer}
              clickable={false}
              style={{
                fontSize: "30px",
              }}
            />
          )}

          <ShimmerPlaceholder
            height="2.75em"
            marginTop="-2em"
            visible={showShimmer}
          />
          {customerDetails?.stage === "DISBURSEMENT_COMPLETED" ? (
            <div
              style={{
                fontSize: "20px",
                lineHeight: "1.1em",
                textAlign: "center",
              }}
            >
              Your Personal Loan of{" "}
              <span style={{ color: "#CB4334", fontWeight: "500" }}>
                {appendRupee(customerDetails?.Data?.cust_accepted_loan_amount)}
              </span>{" "}
              is ready for disbursal. Amount will be credited in your bank account
            </div>
          ) : (
            <div
              style={{
                fontSize: "20px",
                lineHeight: "1.1em",
                textAlign: "center",
              }}
            >
              Please note: Your personal loan is under review for disbursal. Amount will be credited in your bank account post successful verification.
            </div>
          )}
          {/* <SubTitle
              text={
                "Your Personal Loan of " +
                appendRupee(customerDetails?.Data?.cust_accepted_loan_amount) +
                " is ready for disbursal. Amount will be credited in your bank account"
              }
              visible={!showShimmer}
              clickable={false}
              style={{
                fontSize: "20px",
              }}
            /> */}
          {/* <ShimmerPlaceholder
              height="2.5em"
              width="9em"
              visible={showShimmer}
            /> */}
          {/* <Title
              text={appendRupee(
                customerDetails?.Data?.cust_accepted_loan_amount
              )}
              visible={!showShimmer}
              clickable={false}
            /> */}

          <ShimmerPlaceholder
            height="9em"
            width="9em"
            marginTop="-1.5em"
            visible={showShimmer}
          />
          {customerDetails?.stage != "DISBURSEMENT_COMPLETED" ? (
            <img
              style={{
                display: showShimmer ? "none" : "",
                height: "140px",
              }}
              src={Icon_finalOffer_New}
            />
          ) : (
            <img
              style={{
                display: showShimmer ? "none" : "",
                height: "140px",
              }}
              src={Icon_finalOffer}
            />
          )}
          {showShimmer ? (
            <>
              <ShimmerPlaceholder
                height="15em"
                width="22em"
                marginTop="-0.5em"
                visible={showShimmer}
              />
            </>
          ) : (
            <>
              <div className="summary-container">
                <div className="summary-box">
                  <div className="summary-box-inside">
                    <Text
                      text="Approved Loan Summary"
                      id="lsp-summary-title"
                      size="h5"
                    />
                    {customerDetails.source === "upsell" ? (
                      <div id="lsp-approved-summary-detail">
                        <LoanSummaryTextItem
                          title={"Existing Loan Balance"}
                          value={appendRupee(
                            parseInt(customerDetails?.Data?.old_loan_amount) ||
                            0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Top up Loan Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_loan_amount
                            ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Total Loan Amount"}
                          value={appendRupee(
                            parseFloat(
                              customerDetails?.Data?.cust_accepted_loan_amount
                            ) +
                            parseFloat(
                              customerDetails?.Data?.old_loan_amount
                            ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"New Monthly EMI Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_emi
                            ) || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Fees & Charges"}
                          value={appendRupee(
                            parseInt(customerDetails?.Data?.processing_fees_amount) + parseInt(customerDetails?.Data?.foreclosure_amount) ||
                            0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Disbursed Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_loan_amount) -
                            parseInt(customerDetails?.Data?.processing_fees_amount) - parseInt(customerDetails?.Data?.foreclosure_amount)
                            || 0
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"Application no."}
                          value={customerDetails?.application_form_number}
                        />
                        <LoanSummaryTextItem
                          title={"New Loan Tenure"}
                          value={`${customerDetails?.Data?.tenure === "None"
                              ? "0"
                              : customerDetails?.Data?.tenure
                            } Months`}
                        />
                        <LoanSummaryTextItem
                          title={"New Interest Rate"}
                          value={`${customerDetails?.Data?.roi === "None"
                              ? "0"
                              : customerDetails?.Data?.roi
                            }%`}
                        />
                        <LoanSummaryTextItem
                          title={"EMI starts from"}
                          value={convertDate(customerDetails?.Data?.emi_date)}
                        />
                      </div>
                    ) : (
                      <div id="lsp-approved-summary-detail">
                        <LoanSummaryTextItem
                          title={"Loan Amount"}
                          value={appendRupee(
                            customerDetails?.Data?.cust_accepted_loan_amount
                          )}
                        />
                        <LoanSummaryTextItem
                          title={"EMI Amount"}
                          value={appendRupee(
                            parseInt(
                              customerDetails?.Data?.cust_accepted_emi
                            ) || 0
                          )}
                        />
                        {customerDetails?.Data?.cust_ins_choice == "YES" ? (
                          <LoanSummaryTextItem
                            title={"Processing Fees & Charges"}
                            value={appendRupee(Math.ceil(
                              parseFloat(
                                customerDetails?.Data?.processing_fees_amount
                              ) +
                              parseFloat(
                                customerDetails?.Data?.emi_protect_ins
                              ) +
                              parseFloat(
                                customerDetails?.Data?.accident_coverage_ins
                              ) || 0
                            ))}
                          />
                        ) : (
                          <LoanSummaryTextItem
                            title={"Processing Fees & Charges"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.processing_fees_amount
                              ) || 0
                            )}
                          />
                        )}
                        <LoanSummaryTextItem
                          title={"Application no."}
                          value={customerDetails.application_form_number}
                        />
                        {/* <LoanSummaryTextItem
                        title={"Insurance Amount"}
                        value={appendRupee(insuranceAmount)}
                      /> */}
                        <LoanSummaryTextItem
                          title={"Loan Tenure"}
                          value={`${customerDetails?.Data?.tenure === "None"
                              ? "0"
                              : customerDetails?.Data?.tenure
                            } Months`}
                        />
                        <LoanSummaryTextItem
                          title={"Interest Rate"}
                          value={`${customerDetails?.Data?.roi === "None"
                              ? "0"
                              : customerDetails?.Data?.roi
                            }% p.a.`}
                        />
                        <LoanSummaryTextItem
                          title={"EMI starts from"}
                          value={convertDate(customerDetails?.Data?.emi_date)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="bottomDiv">
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  height="3em"
                  width="17em"
                  marginTop="-0.5em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="2.5em"
                  width="8em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                <div className="terms-and-conditions">
                  For loan applications submitted before 5 pm, the loan amount
                  will be credited the same day to your account. For
                  applications submitted on holidays and weekends, the loan
                  amount will be credited on the next working day. The sanction
                  letter and T&Cs has been sent on your registered email ID.
                </div>
                {/* <Button
                  id="Btn"
                  className="Btn"
                  mobile={isMobile}
                  onClick={() => {
                    navigate(customerDetails?.source + "/login", {
                      replace: true,
                    });
                  }}
                  text={"HOME"}
                /> */}
              </>
            )}
          </div>
        </LoanSummaryWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default LoanSummary;
